import {
  useParams,
  useLocation,
  useNavigate
} from "react-router-dom";

import {
  useState,
  useEffect,
  useRef
} from "react";

import MCQLayout from "../components/MCQLayout";

import {
  getMCQContext
} from "../utils/mcqContext";

const FreeMCQPage = () => {

  const { id: teacherId } =
    useParams();

  const location =
    useLocation();

  const navigate =
    useNavigate();

  const [questions, setQuestions] =
    useState([]);

  const [answers, setAnswers] =
    useState({});

  const [submitted, setSubmitted] =
    useState(false);

  const [score, setScore] =
    useState(null);

  const [showReview, setShowReview] =
    useState(false);

  const [showPremium, setShowPremium] =
    useState(false);

  const [loading, setLoading] =
    useState(true);

  const [
    historyReviewMode,
    setHistoryReviewMode
  ] = useState(false);

  /* ================= SUBJECT + TEACHER ================= */

  const [
    apiSubjectName,
    setApiSubjectName
  ] = useState("");

  const [
    apiTeacherName,
    setApiTeacherName
  ] = useState("");

  /* ================= MCQ TYPE ================= */

  const [mcqType, setMcqType] =
    useState("model_papers");

  /* ================= TIMER ================= */

  const EXAM_TIME = 5 * 60;

  const [timeLeft, setTimeLeft] =
    useState(EXAM_TIME);

  const timerRef = useRef(null);

  /* ================= QUERY ================= */

  const queryParams =
    new URLSearchParams(
      location.search
    );

  const moduleId =
    queryParams.get("module_id");

  const isReviewMode =
    queryParams.get("review") === "true";

  const [subjectId, setSubjectId] =
    useState(null);

  /* ================= CONTEXT ================= */

  const context =
    getMCQContext() || {};

  /* ================= REVIEW DATA ================= */

  const reviewHistoryDataRaw =
    localStorage.getItem(
      "review_mcq_data"
    );

  const reviewHistoryData =
    reviewHistoryDataRaw
      ? JSON.parse(
          reviewHistoryDataRaw
        )
      : null;

  /* ================= LOAD REVIEW TYPE ================= */

  useEffect(() => {

    if (!reviewHistoryData)
      return;

    if (
      reviewHistoryData.mcq_type
    ) {

      setMcqType(
        reviewHistoryData.mcq_type
      );

    }

  }, []);

  /* ================= FETCH ================= */

  useEffect(() => {

    if (
      !teacherId ||
      !moduleId
    )
      return;

    setLoading(true);

    fetch(
      `https://edunet.kmechengineering.com/root-engine1/api/mcq-free?teacher_id=${teacherId}&module_id=${moduleId}&mcq_type=${mcqType}&limit=5`
    )

      .then(res => res.json())

      .then(data => {

        console.log(
          "URL REVIEW =>",
          isReviewMode
        );

        console.log(
          "LOCAL STORAGE REVIEW =>",
          reviewHistoryData
        );

        console.log(
          "MCQ API DATA =>",
          data
        );



        /* ================= SUBJECT + TEACHER ================= */

        setApiSubjectName(
          data.subject_name || ""
        );

        setApiTeacherName(
          data.teacher_name || ""
        );

        /* ================= SUBJECT ID ================= */

        const detectedSubjectId =

          data.subject_id ||

          data.mcq_data?.[0]
            ?.subject_id ||

          context.subjectId ||

          null;

        setSubjectId(
          detectedSubjectId
        );

        /* ================= QUESTIONS ================= */

        const formatted =
          (
            data.mcq_data || []
          ).map(q => ({

            id: q.id,

            subject_id:
              q.subject_id,

            question:
              q.question,

            explanation:
              q.explanation,

            options: [

              q.option_a,

              q.option_b,

              q.option_c,

              q.option_d

            ],

            // ================= FIX =================

            correct_answer:
              String(q.correct_answer)
                .trim()
                .toUpperCase()

          }));

        console.log(
          "FORMATTED QUESTIONS =>",
          formatted
        );

        setQuestions(
          formatted
        );

        setLoading(false);

        /* ================= REVIEW MODE ================= */

        if (
          isReviewMode === true &&
          reviewHistoryData !== null
        ) {

          console.log(
            "REVIEW MODE ACTIVE"
          );

          const restoredAnswers = {};

          formatted.forEach(q => {

            restoredAnswers[q.id] =
              reviewHistoryData.answers?.[q.id] || "";

          });

          setAnswers(restoredAnswers);

          setHistoryReviewMode(true);

          setSubmitted(false);

          setScore(
            reviewHistoryData.marks || 0
          );

        }

        else {

          setHistoryReviewMode(false);

          setAnswers({});

          setSubmitted(false);

          setScore(null);

          setShowReview(false);

        }

        setTimeLeft(
          EXAM_TIME
        );

        })

        .catch(err => {

          console.log(err);

          setQuestions([]);

          setLoading(false);

        });

        }, [
          teacherId,
          moduleId,
          mcqType,
          isReviewMode
        ]);

  /* ================= TIMER ================= */

  useEffect(() => {

    if (
      submitted ||
      historyReviewMode
    )
      return;

    timerRef.current =
      setInterval(() => {

        setTimeLeft(t => {

          if (t <= 1) {

            clearInterval(
              timerRef.current
            );

            handleSubmit();

            return 0;

          }

          return t - 1;

        });

      }, 1000);

    return () =>
      clearInterval(
        timerRef.current
      );

  }, [
    submitted,
    historyReviewMode
  ]);

  /* ================= FORMAT TIME ================= */

  const formatTime = () => {

    const m =
      Math.floor(
        timeLeft / 60
      );

    const s =
      timeLeft % 60;

    return `${m
      .toString()
      .padStart(
        2,
        "0"
      )} : ${s
      .toString()
      .padStart(
        2,
        "0"
      )}`;

  };

  /* ================= RETRY ================= */

  const handleRetry = () => {

    if (
      historyReviewMode
    )
      return;

    setSubmitted(false);

    setShowReview(false);

    setShowPremium(false);

    setAnswers({});

    setScore(0);

    setTimeLeft(
      EXAM_TIME
    );

    window.scrollTo({

      top: 0,

      behavior: "smooth"

    });

  };

  /* ================= SUBMIT ================= */

  const handleSubmit =
    async () => {

      if (
        submitted ||
        historyReviewMode
      )
        return;

      if (timerRef.current)
        clearInterval(
          timerRef.current
        );

      let total = 0;

      questions.forEach(q => {

        console.log(
          "COMPARE =>",
          answers[q.id],
          q.correct_answer
        );

        if (
          answers[q.id] ===
          q.correct_answer
        ) {

          total++;

        }

      });

      console.log(
        "FINAL SCORE =>",
        total
      );

      setScore(total);

      setSubmitted(true);



      let guestToken = localStorage.getItem("guest_token");

      if (!guestToken) {
        guestToken = crypto.randomUUID();
        localStorage.setItem("guest_token", guestToken);
      }

      /* ================= SAVE HISTORY ================= */

      try {

        const user =
          JSON.parse(
            localStorage.getItem(
              "user"
            )
          );

        const finalSubjectId =

          subjectId ||

          questions?.[0]
            ?.subject_id ||

          reviewHistoryData
            ?.subject_id ||

          "";

        await fetch(

          "https://edunet.kmechengineering.com/root-engine1/api/mcq-save",

          {

            method: "POST",

            headers: {

              "Content-Type":
                "application/json"

            },

            body: JSON.stringify({
              user_id: user?.id,
              guest_token: guestToken,
              subject_id: finalSubjectId,
              module_id: moduleId,
              teacher_id: teacherId,
              marks: total,
              total_marks: questions.length,
              mcq_type: mcqType,
              answers: answers,
              type: "free"
            })

          }

        );

      }

      catch (err) {

        console.log(err);

      }

    };

  /* ================= LOADING ================= */

  if (loading) {

    return (

      <div
        style={{
          color: "#fff",
          textAlign: "center",
          marginTop: "100px",
          fontSize: "20px",
          fontWeight: "bold"
        }}
      >

        Loading MCQ...

      </div>

    );

  }

  console.log(
    "URL REVIEW =>",
    isReviewMode
  );

  console.log(
    "STATE REVIEW =>",
    historyReviewMode
  );

  return (

    <>

      {!historyReviewMode && (

        <div
          style={
            topSection
          }
        >

          <label
            style={
              radioLabel
            }
          >

           <input
             type="radio"
             name="mcq_type"
             value="model_papers"
             checked={
               mcqType === "model_papers"
             }
             onChange={() =>
               setMcqType("model_papers")
             }
           />

            <span
              style={{
                marginLeft:
                  "8px"
              }}
            >

              Model Papers

            </span>

          </label>

          <label
            style={
              radioLabel
            }
          >

            <input
              type="radio"
              name="mcq_type"
              value="past_papers"
              checked={
                mcqType === "past_papers"
              }
              onChange={() =>
                setMcqType("past_papers")
              }
            />

            <span
              style={{
                marginLeft:
                  "8px"
              }}
            >

              Past Papers

            </span>

          </label>

        </div>

      )}

      <MCQLayout
        title={`Free ${mcqType.toUpperCase()} MCQ (${questions.length})`}
        subject={apiSubjectName || "Subject"}
        teacher={apiTeacherName || "Teacher"}
        questions={questions}
        timeLeft={formatTime()}
        answers={answers}
        submitted={submitted}
        historyReviewMode={historyReviewMode}
        showReview={isReviewMode}
        score={score}
        showPremium={showPremium}

        onContinue={() => {
          setShowPremium(true);
        }}

         onReview={() => {

           const reviewData = {

             answers,
             marks: score,
             total_marks: questions.length,
             subject_id: subjectId,
             teacher_id: teacherId,
             module_id: moduleId,
             mcq_type: mcqType

           };

           console.log(
             "SAVING REVIEW =>",
             reviewData
           );

           localStorage.setItem(
             "review_mcq_data",
             JSON.stringify(reviewData)
           );

           navigate(
             `/mcq/free/teacher/${teacherId}?module_id=${moduleId}&review=true`
           );

         }}

        onAnswer={(id, opt) =>
          setAnswers(prev => ({
            ...prev,
            [id]: opt
          }))
        }

        onSubmit={handleSubmit}
        onRetry={handleRetry}
      />

    </>

  );

};

export default
  FreeMCQPage;

const topSection = {

  width: "100%",

  display: "flex",

  justifyContent:
    "center",

  gap: "20px",

  marginTop: "30px",

  marginBottom:
    "20px"

};

const radioLabel = {

  background: "#fff",

  padding:
    "12px 20px",

  borderRadius:
    "13px",

  fontWeight:
    "bold",

  boxShadow:
    "0 4px 15px rgba(0,0,0,0.1)",

  cursor: "pointer"

};
